import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";

import LeaveForm from "./LeaveForm.jsx";
import TravelForm from "./TravelForm.jsx";
import AttendanceForm from "./AttendanceForm.jsx";
import OTForm from "./OTForm.jsx";
import ListForms from "./ListForms.jsx";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect";
class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAction: null,
            employeeSelectOptions: [],
            selectedEmployeeId: null,
            selectedFormType: null,
            successMessage: null,
            errorMessage: null,
            formErrors: null,
            selectedEmployee: null,
        };
    }

    handleActionSelect = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.setState({
            [name]: value,
            formErrors: null,
        });
    };

    goToDetails = (formType, formId) => {
        this.props.history.push(`/forms/details/${formType}/${formId}`);
    };

    goToList = (employeeId) => {
        this.setState({
            selectedAction: "list",
            selectedEmployeeId: employeeId,
        });
    };

    handleChange = (value) => {
        this.setState({
            selectedEmployeeId: value.value,
            selectedEmployee: value,
        });
    };

    render() {
        const {
            selectedAction,
            selectedEmployeeId,
            selectedFormType,
        } = this.state;
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <FormGroup controlId="formControlsSelect">
                                <ControlLabel>Select Action</ControlLabel>
                                <FormControl
                                    onChange={this.handleActionSelect}
                                    componentClass="select"
                                    name="selectedAction"
                                    value={selectedAction}
                                >
                                    <option value={null}>Select</option>
                                    <option value="add">Create new form</option>
                                    <option value="list">List forms</option>
                                </FormControl>
                            </FormGroup>
                        </Col>
                    </Row>
                    {selectedAction === "add" && (
                        <Row>
                            <Col md={12}>
                                <FormGroup controlId="formControlsSelect">
                                    <ControlLabel>
                                        Select type of form to create
                                    </ControlLabel>
                                    <FormControl
                                        onChange={this.handleActionSelect}
                                        componentClass="select"
                                        name="selectedFormType"
                                        value={selectedFormType}
                                    >
                                        <option value="">Select</option>
                                        <option value="leave">Leave</option>
                                        <option value="undertime">
                                            Undertime
                                        </option>
                                        <option value="travel-order">
                                            Travel Order
                                        </option>
                                        <option value="attendance">
                                            Attendance
                                        </option>
                                        <option value="ot-request">
                                            OT Request
                                        </option>
                                    </FormControl>
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    {selectedAction === "add" &&
                        selectedFormType === "leave" && (
                            <LeaveForm
                                key="leave"
                                applicationType="leave"
                                goToList={this.goToList}
                            />
                        )}
                    {selectedAction === "add" &&
                        selectedFormType === "undertime" && (
                            <LeaveForm
                                key="undertime"
                                applicationType="undertime"
                                goToList={this.goToList}
                            />
                        )}
                    {selectedAction === "add" &&
                        selectedFormType === "travel-order" && (
                            <TravelForm goToList={this.goToList} />
                        )}
                    {selectedAction === "add" &&
                        selectedFormType === "attendance" && (
                            <AttendanceForm goToList={this.goToList} />
                        )}
                    {selectedAction === "add" &&
                        selectedFormType === "ot-request" && (
                            <OTForm goToList={this.goToList} />
                        )}
                    {selectedAction === "list" && (
                        <Row>
                            <Col md={12}>
                                <ControlLabel>Select Employee </ControlLabel>
                                <EmployeeAsyncSelect
                                    onChange={this.handleChange}
                                />
                            </Col>
                        </Row>
                    )}
                    {selectedAction === "list" && selectedEmployeeId && (
                        <ListForms
                            id={selectedEmployeeId}
                            goToDetails={this.goToDetails}
                        />
                    )}
                </Grid>
            </div>
        );
    }
}

export default Form;
